import { trigger, transition, style, animate } from '@angular/animations';

export const fadeInRight = trigger('fadeInRight', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(1000px)' }),
    animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
  ]),
]);

export const fadeOutRight = trigger('fadeOutRight', [
  transition(':leave', [animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(1000px)' }))]),
]);
